import tw, { styled } from "twin.macro";

import {
  Menu,
  MenuItem,
  MenuLeftColContent,
  MenuLeftProduct,
  MenuLeftRow,
} from "./MenuStyles";
import { features } from "./navItems";
import {
  ConvertLink,
  CustomerPortalLink,
  ReactivateLink,
  RetainLink,
} from "./SolutionLink";

const Solutions = styled.div`
  ${tw`flex gap-3 w-full`}
`;

const ProductMenu: React.FunctionComponent = () => (
  <Menu>
    <MenuLeftProduct>
      <MenuLeftRow>
        <h5>Solutions</h5>
        <MenuLeftColContent>
          <Solutions>
            <RetainLink />
            <ConvertLink />
            <ReactivateLink />
            <CustomerPortalLink />
          </Solutions>
        </MenuLeftColContent>
      </MenuLeftRow>
      <MenuLeftRow>
        <h5>Features</h5>
        <MenuLeftColContent>
          <div tw="flex-grow">
            {features.slice(0, 2).map((link, i) => (
              <MenuItem to={link.to} key={link.to}>
                {link.icon && <>{link.icon}&nbsp;</>}
                {link.title}
              </MenuItem>
            ))}
            {features.slice(6).map((link) => (
              <MenuItem to={link.to} key={link.to}>
                {link.icon && <>{link.icon}&nbsp;</>}
                {link.title}
              </MenuItem>
            ))}
          </div>
          <div tw="flex-grow">
            {features.slice(2, 4).map((link) => (
              <MenuItem to={link.to} key={link.to}>
                {link.icon && <>{link.icon}&nbsp;</>}
                {link.title}
              </MenuItem>
            ))}
          </div>
          <div tw="flex-grow">
            {features.slice(4, 6).map((link) => (
              <MenuItem to={link.to} key={link.to}>
                {link.icon && <>{link.icon}&nbsp;</>}
                {link.title}
              </MenuItem>
            ))}
          </div>
        </MenuLeftColContent>
      </MenuLeftRow>
    </MenuLeftProduct>
  </Menu>
);

export default ProductMenu;
